export default "__VITE_ASSET__Pu$bRRwe__"